import { render, staticRenderFns } from "./ModalTestingResults_2.vue?vue&type=template&id=704a8ffa&"
import script from "./ModalTestingResults_2.vue?vue&type=script&lang=js&"
export * from "./ModalTestingResults_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports